<template>
    <b-container fluid class="mt-2 px-1 px-sm-3 pb-2 team-page">
        <b-row>
            <b-col cols="" class="">
                <b-row>
                    <b-col cols="">
                        <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-3">
                            <h2 class="text-left mb-0">{{ $t('recruitingReport.title') }}</h2>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <div class="data-table team-data-table pt-2 bg-white rounded table-custom-border">
                    <div class="table_row team_table_row">
                        <div class="equipment-border filter-box filter-report-box" v-if="isTableMounted">
                            <div class="d-flex mb-0 px-3 px-sm-4 flex-wrap mt-3 gap-2">
                                <b-form-group :label="$t('recruitingReport.selectDate')"
                                    class="text-left select_arrow label report-fields">
                                    <b-form-select class="input f-12" :options="[
                                        {
                                            value: '',
                                            text: $t('maintenanceTotals.all'),
                                        }, ...getRemainingQuarters()
                                    ]" v-model="filterFields.date" @change="getTableData()"></b-form-select>
                                </b-form-group>

                                <b-form-group :label="$t('recruitingReport.selectRecruiter')"
                                    class="text-left report-fields">
                                    <v-select :disabled="isBusy" :options="nameOptions" class="f-12"
                                        :reduce="(option) => option.id" v-model="filterFields.owner" @input="getTableData()"
                                        @search="searchUsers" />
                                </b-form-group>
                            </div>
                        </div>
                        <div v-if="!isTableMounted" class="mt-2" style="height: calc(100vh - 170px); overflow: hidden;">
                            <b-skeleton-table :rows="17" :columns="7"
                                :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
                        </div>
                        <b-table :sticky-header="'calc(100vh - 300px)'" v-else class="mt-2" responsive :fields="translatedFields" :items="items" hover
                            :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                            :no-local-sorting="true" :busy.sync="isBusy" :show-empty="emptyTable">
                            <template #cell(missing_doc_type_ids)="data">
                                <div>
                                    {{ data.value.length ? getDocTypeID(data.value) : '-' }}
                                </div>
                            </template>
                            <template #cell(action)="data">
                                <svg v-if="checkCreateDocStatus(data.item.type)" @click="addRequiredDoc(data.item)"
                                    class="cursor-pointer" width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="10" cy="10" r="10" fill="#2D69F6" />
                                    <path
                                        d="M10 13.3334V10.0001V13.3334ZM10 10.0001V6.66675V10.0001ZM10 10.0001H13.3334H10ZM10 10.0001H6.66669H10Z"
                                        fill="#2D69F6" />
                                    <path d="M10 13.3334V10.0001M10 10.0001V6.66675M10 10.0001H13.3334M10 10.0001H6.66669"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round" />
                                </svg>
                                <span v-else>-</span>
                            </template>
                            <template #cell(hired_pct)="data">
                                <div :class="pctClass(data.value)">
                                    {{ data.value !== '-' ? data.value + '%' : '-' }}
                                </div>
                            </template>
                            <template #cell(expand)="row">
                                <button v-if="Array.isArray(row.item.drivers) && row.item.drivers.length" type="button"
                                    class="rr-expand-btn" @click="row.toggleDetails">
                                    {{ row.detailsShowing ? '−' : '+' }}
                                </button>
                                <span v-else>-</span>
                            </template>
                            <template #row-details="row">
                                <div class="rr-drill-inner">
                                    <div class="rr-drill-stats">
                                        <div class="rr-chip">{{ $t('recruitingReport.addedColumn') }}<b>{{
                                            driverStats(row.item.drivers).added }}</b></div>
                                        <div class="rr-chip">{{ $t('recruitingReport.appliedColumn') }}<b>{{
                                            driverStats(row.item.drivers).applied }}</b></div>
                                        <div class="rr-chip">{{ $t('recruitingReport.inProgressColumn') }}<b>{{
                                            driverStats(row.item.drivers).inProgress }}</b></div>
                                        <div class="rr-chip">{{ $t('recruitingReport.leadClosedColumn') }}<b>{{
                                            driverStats(row.item.drivers).leadClosed }}</b></div>
                                        <div class="rr-chip">{{ $t('recruitingReport.rejectedColumn') }}<b>{{
                                            driverStats(row.item.drivers).rejected }}</b></div>
                                        <div class="rr-chip">{{ $t('recruitingReport.hiredColumn') }}<b>{{
                                            driverStats(row.item.drivers).hired }}</b></div>
                                        <div class="rr-chip">{{ $t('recruitingReport.terminatedColumn') }}<b>{{
                                            driverStats(row.item.drivers).terminated }}</b></div>
                                    </div>
                                    <div class="table-responsive">
                                        <table class="rr-drill-table">
                                            <thead>
                                                <tr>
                                                    <th>{{ $t('recruitingReport.driverColumn') }}</th>
                                                    <th>{{ $t('recruitingReport.addedDateColumn') }}</th>
                                                    <th>{{ $t('recruitingReport.appliedDateColumn') }}</th>
                                                    <th>{{ $t('recruitingReport.hiredQColumn') }}</th>
                                                    <th>{{ $t('recruitingReport.hiredDateColumn') }}</th>
                                                    <th>{{ $t('recruitingReport.terminatedDateColumn') }}</th>
                                                    <th>{{ $t('recruitingReport.statusColumn') }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="d in sortedDrivers(row.item.drivers)" :key="d.id">
                                                    <td>{{ d.name }}</td>
                                                    <td>{{ fmtDate(d.added_date) }}</td>
                                                    <td>{{ fmtDate(d.applied_date) }}</td>
                                                    <td>{{ d.hired_date ? $t('recruitingReport.yes') :
                                                        $t('recruitingReport.no') }}</td>
                                                    <td>{{ fmtDate(d.hired_date) }}</td>
                                                    <td>{{ fmtDate(d.terminated_date) }}</td>
                                                    <td><span class="rr-status-badge" :class="statusClass(d.status)">{{
                                                        d.status }}</span></td>
                                                </tr>
                                                <tr v-if="!sortedDrivers(row.item.drivers).length">
                                                    <td colspan="7" class="rr-empty">{{ $t('recruitingReport.noDrivers') }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </template>
                            <template v-slot:custom-foot>
                                <td class="text-left"><span class="font-weight-bold pl-0">Report totals</span> <br />{{
                                    items.length }} recruiters</td>
                                <td class="text-left">{{ totals.added }}</td>
                                <td class="text-left">{{ totals.applied }}</td>
                                <td class="text-left">{{ totals.in_progress }}</td>
                                <td class="text-left">{{ totals.lead_closed }}</td>
                                <td class="text-left">{{ totals.rejected }}</td>
                                <td class="text-left">{{ totals.hired }}</td>
                                <td class="text-left">{{ totals.terminated }}</td>
                                <td class="text-left" :class="pctClass(totals.hired_pct)">{{ totals.hired_pct }}%</td>
                                <td></td>
                            </template>
                        </b-table>
                        <div class="entries-pagination px-0 px-sm-2" v-if="isTableMounted">
                            <div class="d-flex align-items-center flex-wrap">
                                <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                                    <b-form-select v-model="perPage" :options="pageOptions" />
                                </div>
                                <div class="pagination">
                                    <b-pagination v-model="currentPage" :total-rows="rows"
                                        :per-page="perPage"></b-pagination>
                                </div>
                                <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">{{ positionText }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
        <AddDoc :docData="docData" @close="docData = null" @onAddDoc="getTableData()" />
    </b-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import * as moment from "moment-timezone";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css"
import AddDoc from './AddDoc.vue';

const IN_PROGRESS_STATUSES = ['New Lead', 'Contacted', 'Applied', 'Under Review', 'Screening', 'Onboarding'];
export default {
    name: "RecruitingReport",
    components: { vSelect, AddDoc },
    data() {
        return {
            docData: null,
            pageOptions: [
                {
                    value: 10,
                    text: "10",
                },
                {
                    value: 25,
                    text: "25",
                },
                {
                    value: 50,
                    text: "50",
                },
                {
                    value: 100,
                    text: "100",
                },
            ],
            items: [],
            sortBy: undefined,
            emptyTable: false,
            sortDesc: undefined,
            isBusy: false,
            isTableMounted: false,
            perPage: 10,
            currentPage: 1,
            docTypeOptions: [],
            totals: null,
            nameOptions: [],
            filterFields: {
                year: '',
                month: '',
                owner: ''
            },
        }
    },
    computed: {
        ...mapGetters(["company", 'userCompany', 'rolePermissions', 'divisions', 'allTeamMembers']),
        rows() {
            return this.items.length;
        },
        positionText() {
            const endIndex = this.currentPage * this.perPage;
            const startIndex = this.rows > 0 ? (this.currentPage - 1) * this.perPage + 1 : 0;
            const end = endIndex > this.rows ? this.rows : endIndex;
            return this.$t('customFields.positionText', { start: startIndex, end, total: this.rows });
        },
        translatedFields() {
            return [
                { label: this.$t('recruitingReport.recruiterColumn'), key: "recruiter", sortable: true, tdClass: "align-middle", field: "text", thClass: 'font-table-weight-bold', stickyColumn: true },
                { label: this.$t('recruitingReport.addedColumn'), key: "added", sortable: true, tdClass: "align-middle", field: "text", thClass: 'font-table-weight-bold' },
                { label: this.$t('recruitingReport.appliedColumn'), key: "applied", sortable: true, tdClass: "align-middle", field: "text", thClass: 'font-table-weight-bold' },
                { label: this.$t('recruitingReport.inProgressColumn'), key: "in_progress", sortable: true, tdClass: "align-middle", field: "text", thClass: 'font-table-weight-bold' },
                { label: this.$t('recruitingReport.leadClosedColumn'), key: "lead_closed", sortable: true, tdClass: "align-middle", field: "text", thClass: 'font-table-weight-bold' },
                { label: this.$t('recruitingReport.rejectedColumn'), key: "rejected", sortable: true, tdClass: "align-middle", field: "text", thClass: 'font-table-weight-bold' },
                { label: this.$t('recruitingReport.hiredColumn'), key: "hired", sortable: true, tdClass: "align-middle", field: "text", thClass: 'font-table-weight-bold' },
                { label: this.$t('recruitingReport.terminatedColumn'), key: "terminated", sortable: true, tdClass: "align-middle", field: "text", thClass: 'font-table-weight-bold' },
                { label: this.$t('recruitingReport.hiredPctColumn'), key: "hired_pct", sortable: true, tdClass: "align-middle", field: "text", thClass: 'font-table-weight-bold' },
                { label: '', key: "expand", sortable: false, tdClass: "align-middle text-center", thClass: 'font-table-weight-bold', class: 'rr-expand-col' }
            ];
        },
        requiredOptions() {
            return [
                { value: '', text: '' },
                { value: 'True', text: this.$t('requiredDocs.yes') },
                { value: 'False', text: this.$t('requiredDocs.no') },
            ];
        },
        allowViewDocDrivers() {
            return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][7].allow
        },
        allowViewDocEquipment() {
            return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][6].allow
        },
        allowViewDocCompany() {
            return this.rolePermissions && this.rolePermissions['Company Documents'] && this.rolePermissions['Company Documents'][0].allow
        },
        allowCreateDocDrivers() {
            return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][9].allow
        },
        allowCreateDocEquipment() {
            return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][8].allow
        },
        typeOptions() {
            const options = [
                {
                    value: "",
                    text: "",
                },
            ];
            if (this.allowViewDocEquipment) {
                options.push({
                    value: "Vehicle",
                    text: this.$t('requiredDocs.vehicle'),
                })
                options.push(
                    {
                        value: "Trailer",
                        text: this.$t('requiredDocs.trailer'),
                    })
            }
            if (this.allowViewDocDrivers) {
                options.push({
                    value: "Driver",
                    text: this.$t('requiredDocs.driver'),
                });
            }
            return options;
        },
        allDivisions() {
            return this.divisions.map((item) => {
                return {
                    id: item.id,
                    label: item.division,
                }
            })
        },
    },
    methods: {
        ...mapActions(['getAllTeamMembers', 'getRecruitingReport', 'setLoader', 'setNotification', 'exportAllRequiredDocsData']),
        checkCreateDocStatus(type) {
            if (type === 'Driver' && this.allowCreateDocDrivers) return true
            else if ((type === 'Equipment' || type === 'Vehicle' || type === 'Trailer') && this.allowCreateDocEquipment) return true
            else return false
        },
        getRemainingQuarters() {
            const result = [];
            const startYear = 2025;
            const startMonth = 0; // Jan
            const now = new Date();

            const currentYear = now.getFullYear();
            const currentMonth = now.getMonth();

            const monthNames = [
                "Jan", "Feb", "Mar",
                "Apr", "May", "Jun",
                "July", "Aug", "Sept",
                "Oct", "Nov", "Dec"
            ];

            const pad = (n) => String(n).padStart(2, "0");

            const lastDayOfMonth = (y, m) =>
                new Date(y, m + 1, 0).getDate();

            for (let year = currentYear; year >= startYear; year--) {

                // ---------- YEAR (always full year) ----------
                result.push({
                    text: `${year}`,
                    value: `start_date=${year}-01-01&end_date=${year}-12-31`,
                    type: "year"
                });

                for (let q = 4; q >= 1; q--) {
                    const qStart = (q - 1) * 3;
                    const qEnd = qStart + 2;

                    // ❌ Skip quarters that haven't started yet (current year only)
                    if (year === currentYear && qStart > currentMonth) continue;

                    // ❌ Skip quarters before Jan 2025
                    if (year === startYear && qEnd < startMonth) continue;

                    const qStartDate = `${year}-${pad(qStart + 1)}-01`;
                    const qEndDate = `${year}-${pad(qEnd + 1)}-${lastDayOfMonth(year, qEnd)}`;

                    // ---------- QUARTER ----------
                    result.push({
                        text: `${year} Q${q}`,
                        value: `start_date=${qStartDate}&end_date=${qEndDate}`,
                        type: "quarter"
                    });

                    // ---------- MONTHS ----------
                    for (let m = qEnd; m >= qStart; m--) {

                        // ❌ Future months (current year)
                        if (year === currentYear && m > currentMonth) continue;

                        // ❌ Before Jan 2025
                        if (year === startYear && m < startMonth) continue;

                        const mStart = `${year}-${pad(m + 1)}-01`;
                        const mEnd = `${year}-${pad(m + 1)}-${lastDayOfMonth(year, m)}`;

                        result.push({
                            text: `${year} ${monthNames[m]}`,
                            value: `start_date=${mStart}&end_date=${mEnd}`,
                            type: "month"
                        });
                    }
                }
            }

            return result;
        },

        async searchUsers(searchText) {
            let options = []
            let url = `page=1&page_size=20&name=${searchText}`;
            await this.getAllTeamMembers(url);
            this.allTeamMembers.map((member) => {
                options.push({
                    id: `${member.id}`,
                    label: member.user.first_name + ' ' + member.user.last_name,
                });
            });
            this.nameOptions = options
            this.nameOptions = [...new Map(this.nameOptions.map(item => [item['id'], item])).values()]
        },
        addRequiredDoc(data) {
            this.docData = data
            this.$bvModal.show('modal-add-document')
        },
        setDocTypeData() {
            if (this.filterFields.type) {
                this.docTypeOptions = [...[{
                    value: "",
                    text: "",
                }], ...this.docTypeItems?.filter((item) => item.model === this.filterFields.type && (!this.filterFields.required || this.filterFields.required === "True" && item.required || this.filterFields.required === "False" && !item.required)).map((item) => {
                    return {
                        value: item.id,
                        text: item.type,
                    }
                })]
            }
            else this.docTypeOptions = []
            this.getTableData()
        },

        getDocTypeID(data) {
            const docTypItems = data.map(id => {
                const foundItem = this.docTypeItems.find(item => item.id === id);
                if (foundItem) {
                    return foundItem.type
                }
            });
            return docTypItems.join(", ")
        },
        driverStats(drivers) {
            const list = Array.isArray(drivers) ? drivers : [];
            return {
                added: list.length,
                applied: list.filter(d => d.applied_date).length,
                inProgress: list.filter(d => IN_PROGRESS_STATUSES.includes(d.status)).length,
                leadClosed: list.filter(d => d.status === 'Lead Closed').length,
                rejected: list.filter(d => d.status === 'Rejected').length,
                hired: list.filter(d => d.status === 'Hired').length,
                terminated: list.filter(d => d.status === 'Terminated').length,
            };
        },
        sortedDrivers(drivers) {
            const list = Array.isArray(drivers) ? [...drivers] : [];
            return list.sort((a, b) => {
                const da = a.added_date ? new Date(a.added_date).getTime() : 0;
                const db = b.added_date ? new Date(b.added_date).getTime() : 0;
                return db - da;
            });
        },
        fmtDate(str) {
            if (!str || str === '-') return '—';
            const d = moment(str);
            return d.isValid() ? d.format('ll') : '—';
        },
        statusClass(status) {
            return 'st-' + (status || '').replace(/[^A-Za-z]/g, '');
        },
        pctClass(value) {
            if (value === '-' || value === null || value === undefined) return '';
            const p = parseFloat(value);
            if (isNaN(p)) return '';
            if (p >= 60) return 'pct-green'; // higher = better (hire rate)
            if (p >= 30) return 'pct-orange';
            return 'pct-red';
        },
        async getTableData() {
            try {
                this.isBusy = true
                let url = ""
                Object.keys(this.filterFields).map((key) => {
                    if (key === 'date' && this.filterFields[key]) {
                        url += `${this.filterFields[key]}&`
                    }
                    else if (this.filterFields[key] && key !== 'date') {
                        url += `${key}=${this.filterFields[key]}&`
                    }
                })
                if (this.sortBy) {
                    url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
                }
                else {
                    url += `sort_field=name&sort_order=asc&`
                }
                url += `page=${this.currentPage}&page_size=${this.perPage}`
                const data = await this.getRecruitingReport(url);

                this.items = []
                data.rows.map((item) => {
                    const tableItem = {}
                    Object.keys(item).map((key) => {
                        if (item[key]) tableItem[key] = item[key]
                        else tableItem[key] = "-"
                    })
                    this.items.push(tableItem)
                })
                this.totals = data.totals
                if (this.items.length === 0) this.emptyTable = true
                else this.emptyTable = false
                this.isBusy = false
                this.isTableMounted = true
            }
            catch (e) {
                this.isBusy = false
                this.isTableMounted = true
                console.log(e)
            }
        },
    },
    watch: {
        perPage: {
            async handler() {
                await this.getTableData();
            },
            immediate: true,
        },
        currentPage: {
            async handler() {
                await this.getTableData();
            },
        },
        sortBy: {
            async handler() {
                await this.getTableData();
            },
        },
        sortDesc: {
            async handler() {
                await this.getTableData();
            },
        },
        filterFields: {
            handler() {
                this.currentPage = 1
            },
            deep: true
        },

    }
}
</script>
<style scoped>
.rr-expand-col {
    width: 48px;
}

.rr-expand-btn {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid #e2e6f0;
    background: #fff;
    color: #2d69f6;
    font-size: 15px;
    line-height: 1;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    transition: background 0.15s ease, border-color 0.15s ease;
}

.rr-expand-btn:hover {
    background: #eff6ff;
    border-color: #2d69f6;
}

.rr-drill-inner {
    padding: 8px 4px 4px;
    text-align: left;
}

.rr-drill-stats {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 14px;
}

.rr-chip {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 8px 14px;
    font-size: 12.5px;
    color: #6b7280;
}

.rr-chip b {
    display: block;
    font-size: 16px;
    margin-top: 2px;
    color: #111827;
}

.rr-drill-table {
    width: 100%;
    border-collapse: collapse;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
}

.rr-drill-table th {
    text-align: left;
    font-size: 11px;
    letter-spacing: .04em;
    color: #6b7280;
    font-weight: 600;
    padding: 10px 12px;
    border-bottom: 1px solid #e5e7eb;
    white-space: nowrap;
}

.rr-drill-table td {
    padding: 10px 12px;
    border-bottom: 1px solid #f0f1f4;
    vertical-align: middle;
    font-size: 13px;
    color: #111827;
}

.rr-drill-table tr:last-child td {
    border-bottom: none;
}

.rr-empty {
    color: #8290ac;
    text-align: center;
}

.rr-status-badge {
    display: inline-block;
    padding: 2px 9px;
    border-radius: 99px;
    font-size: 11.5px;
    font-weight: 600;
}

.st-NewLead {
    background: #eef2ff;
    color: #4338ca;
}

.st-Contacted {
    background: #f0f9ff;
    color: #0369a1;
}

.st-Applied {
    background: #fefce8;
    color: #a16207;
}

.st-UnderReview {
    background: #fff7ed;
    color: #c2410c;
}

.st-Screening {
    background: #fdf4ff;
    color: #a21caf;
}

.st-Onboarding {
    background: #eff6ff;
    color: #1d4ed8;
}

.st-Hired {
    background: #ecfdf5;
    color: #047857;
}

.st-Terminated {
    background: #fef2f2;
    color: #b91c1c;
}

.st-Rejected {
    background: #f5f5f5;
    color: #525252;
}

.st-LeadClosed {
    background: #f5f5f4;
    color: #78716c;
}

.pct-green {
    color: #059669;
    font-weight: 600;
}

.pct-orange {
    color: #d97706;
    font-weight: 600;
}

.pct-red {
    color: #dc2626;
    font-weight: 600;
}</style>